import { useRouter } from 'next/router';
import { useCallback } from 'react';

import type { IAuth } from '@/Module/Auth/Model/DataModel';
import { authGetCategoryByGradeIdAction, authGetMyPersonAction } from '@/Module/Auth/Store/Action';
import { enqueueError } from '@/Module/Core/Helper';
import { CookieService } from '@/Module/Core/Service';
import { useAppDispatch } from '@/Module/Store/Hook';
import {
  getSubscriptionPlanListAction,
  getSubscriptionsV2UserAction,
  getSubscriptionTypeListAction,
} from '@/Module/Subscription/Store/Action';

export const useLogin = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();

  const loginViaMessenger = useCallback(
    async (data: IAuth) => {
      CookieService.setAccessToken(data.accessToken);
      CookieService.setRefreshToken(data.refreshToken);

      await dispatch(authGetMyPersonAction(data.accessToken))
        .unwrap()
        .then(async person => {
          await Promise.all([
            dispatch(getSubscriptionsV2UserAction(data.accessToken)),
            dispatch(authGetCategoryByGradeIdAction(person?.gradeId || 15)),
            dispatch(getSubscriptionTypeListAction()),
            dispatch(getSubscriptionPlanListAction()),
          ]);
        })
        .catch(() => {
          enqueueError('مشکلی در ورود شما پیش آمده، لطفاً از برنامه خارج شده و مجدداً وارد شوید.');
        });
    },
    [dispatch, router],
  );

  return { loginViaMessenger };
};
